import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialTikTokPaymentsReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const tiktokPaymentsSlice = createSlice({
    name: "TikTok Payments",
    initialState: { ...initialTikTokPaymentsReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default tiktokPaymentsSlice;
